import { render, staticRenderFns } from "./Activity13.vue?vue&type=template&id=5744bb7f&scoped=true"
import script from "./Activity13.vue?vue&type=script&lang=js"
export * from "./Activity13.vue?vue&type=script&lang=js"
import style0 from "./Activity13.vue?vue&type=style&index=0&id=5744bb7f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5744bb7f",
  null
  
)

export default component.exports